<template lang="pug">
  .scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tabHead")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
        tbody.table__body(v-for="item in tabData")
          tr.table__row
            td.table__cell
              .table__cell-content {{item.house.name}}
            td.table__cell
              .table__cell-content {{ item.price }}
            td.table__cell
              .table__cell-content {{ item.capacity }}
            td.table__cell.fixed
              .table__cell-content.table__cell-content_align-right
                button.button.button_square.table__cell-control(
                @click.prevent="onEditQuotaHouse(item)"
                )
                  img(src="@/assets/images/icons/icon-edit.svg")
                button.button.button_square.table__cell-control(
                @click.prevent="onDeleteQuotaHouse(item)"
                )
                  img(src="@/assets/images/icons/trash.svg")
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "ManagerShiftsHousesRegistryScrollFixTable",
  props: [
    "tab-data",
    "tab-head"
  ],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  },
  methods: {
    onEditQuotaHouse(house) {
      this.$emit("on-edit-quota-house", house);
    },
    onDeleteQuotaHouse(house) {
      this.$emit("on-delete-quota-house", house);
    }
  }
};
</script>
